
import { calculateDimensionScores, calculateOverallScore, generateAssessmentReport } from "@/utils/scoring";
import { Answer } from "@/types/assessment";
import { questions } from "@/data/questions";

export const useAssessmentResults = (answers: Answer[], showResults: boolean) => {
  if (!showResults) {
    return null;
  }

  const dimensionScores = calculateDimensionScores(answers, questions);
  const overallScore = calculateOverallScore(dimensionScores);
  const report = generateAssessmentReport(dimensionScores, overallScore);
  
  const dimensionScoresRecord = dimensionScores.reduce((acc, curr) => {
    acc[curr.dimension] = curr.score;
    return acc;
  }, {} as Record<string, number>);

  return {
    dimensionScores,
    overallScore,
    report,
    dimensionScoresRecord
  };
};
